import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from 'utils/apollo/apolloClient';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';

export const SamplesApolloProvider = ({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement => {
    const { deviceType } = useExecutionEnvironmentContext();

    return (
        <ApolloProvider client={apolloClient(deviceType)}>
            {children}
        </ApolloProvider>
    );
};

export default SamplesApolloProvider;
